import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ISubscriptionResponse } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getSubscriptionDetailsUUID = createUUID();
const getSubscriptionsUUID = createUUID();

export const useSubscriptions = () => {
  const stateManager = useComponentState();
  const [subscriptionDetails, setSubscriptionDetails] =
    useState<ISubscriptionResponse | null>(null);
  const [subscriptions, setSubscriptions] = useState<ISubscriptionResponse[]>(
    []
  );

  const getSubscriptions = () => {
    stateManager.abort(getSubscriptionsUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.subscriptions.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        setSubscriptions(response.data);
      }
      return response;
    }, getSubscriptionsUUID);
  };

  const getSubscriptionDetails = (id: string) => {
    stateManager.abort(getSubscriptionDetailsUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.subscriptions.get(id);
      if (response.status === HTTP_STATUSES.OK) {
        setSubscriptionDetails(response.data);
      }
      return response;
    }, getSubscriptionDetailsUUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    subscriptions,
    subscriptionDetails,
    getSubscriptions,
    getSubscriptionDetails,
    setSubscriptions,
    setSubscriptionDetails,
  };
};
